"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toFootnotesSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toFootnotesSlice = function (data, logger) {
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.Footnotes)), { footnotes: data === null || data === void 0 ? void 0 : data.items.map(function (item) {
            return logger.required(fields_1.toRichText(item.text, logger));
        }) }));
};
exports.toFootnotesSlice = toFootnotesSlice;
//# sourceMappingURL=footnotes-slice.js.map